import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const DocumentIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/document"><path id="Icon" d="M3.59998 3.4C3.59998 2.40589 4.40586 1.6001 5.39998 1.6001H13.6544C14.1318 1.6001 14.5896 1.79243 14.9272 2.13L19.8728 7.07C20.2103 7.40757 20.4 7.87261 20.4 8.35V20.6001C20.4 21.5942 19.5941 22.4001 18.6 22.4001H5.39998C4.40586 22.4001 3.59998 21.5942 3.59998 20.6001V3.4Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DocumentIcon;